export var ProjectStatus;
(function (ProjectStatus) {
    ProjectStatus["Approved"] = "approved";
    ProjectStatus["ProjectAccepted"] = "projectAccepted";
    ProjectStatus["Rejected"] = "rejected";
    ProjectStatus["DeliveryPending"] = "deliveryPending";
    ProjectStatus["DeliveryRejected"] = "deliveryRejected";
    ProjectStatus["ProjectDelivered"] = "projectDelivered";
    ProjectStatus["Pending"] = "pending";
})(ProjectStatus || (ProjectStatus = {}));
